<div class="screener-container">
  <div class="ai-screening-loader" id="taxonomy-loader" *ngIf="showLoader">
        <div class="aiscreen-loader-box">
            <div class="loader-star">
              <i class="fa-solid fa-stars"></i>
            </div>
            <div class="plz-wait-text">
              Please wait
            </div>
              <div class="progress">
                  <div class="progress-bar progress-bar-animated" role="progressbar" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100" style="max-width: 100%">
                  </div>
                </div>
                <div class="progressvalue">
                 {{progressValue}}% Completed
                </div>
                <div class="loader-text-on-value">
                  <p [ngClass]="{'active': (progressValue>5 && progressValue<25)}"> <i class="fa-solid fa-file-import"></i>Analyzing your Job Description with AI...</p>
                  <p [ngClass]="{'active': (progressValue>=25 && progressValue<50)}"> <i class="fa-solid fa-file-pdf"></i> Understanding context beyond keywords...</p>
                  <p [ngClass]="{'active': (progressValue>=50 && progressValue<70)}"> <i class="fa-solid fa-calendar-lines-pen"></i>Ranking candidates on your hiring criteria...</p>
                  <p [ngClass]="{'active': (progressValue>=70 && progressValue<100)}"><i class="fa-solid fa-users"></i> Almost there — results loading!...</p>
                </div>
        </div>
  </div>
  <div *ngIf="!showLoader && candidatelist?.length">
<h2 class="text-center font-weight-600 text-black mb-4 f-24">Here are the results</h2>
<div class="col-md-9 mx-auto">
  <button data-testid="auto-app-userprofile-button-1" class="btn-trms-regular d-flex ml-auto mb-4 align-items-center" matTooltip="File Sent" [matTooltipClass]="{ 'red-tooltip text-black': true }" (click)="openExportCsvEmailModal()">
    <i class="fa-solid fa-file-csv"></i> Export CSV
  </button>
  <div class="user-card" *ngFor="let candidate of candidatelist">
    <div>
      <h2>{{ candidate?.firstname }} {{ candidate?.lastname }} <span (click)="openPDF(candidate)" class="pointer"><i class="fa-solid fa-file-pdf" matTooltip="View Resume" [matTooltipClass]="{ 'red-tooltip text-black': true }"></i></span></h2>
      <p *ngIf="candidate?.currentjobtitle && candidate?.currentcompany">{{ candidate?.currentjobtitle }} at {{ candidate?.currentcompany }}</p>
      <p *ngIf="!candidate?.currentjobtitle && !candidate?.currentcompany" class="f-12 text-9696 d-flex align-items-center"><i class="fa-regular fa-briefcase mr-1"></i> Designation <span class="d-flex"><i class="fa-solid fa-circle mx-2" style="color: #2E93A1; font-size: 5px;"></i></span> <span><i class="fa-regular fa-buildings mr-1"></i></span> Company</p>
    </div>
    <div style="width: 200px;" class="d-flex">
        <div class="percentage-match" [ngClass]="{
           'excellent-match-btn': candidate?.category == 'EXCELLENT',
          'good-match-btn': candidate?.category == 'GOOD',
          'potential-match-btn': candidate?.category == 'POTENTIAL',
          'notamatch-match-btn': candidate?.category == 'NOT_A_MATCH'
        }" (click)="openPercentageMatchModal(candidate)">{{candidate?.overall_screening_score}} % | {{showMatchScore(candidate?.category)}} <i class="fa-solid fa-chevron-right"></i></div>
    </div>
  </div>
</div>
  </div>
</div>
<ng-template #percentageMatchModal>
 <div class="modal-body">
  <div class="d-flex justify-content-between align-items-start">
    <div class="row w-100">
      <div class="col-md-8">
        <h2>{{candidateData?.firstname}} {{candidateData?.lastname}} <span (click)="openPDF(candidateData)" class="pointer"><i class="fa-solid fa-file-pdf" matTooltip="View Resume" [matTooltipClass]="{ 'red-tooltip text-black': true }"></i></span></h2>
        <p *ngIf="candidateData?.currentjobtitle && candidateData?.currentcompany">{{ candidateData?.currentjobtitle }} at {{ candidateData?.currentcompany }}</p>
      <p *ngIf="!candidateData?.currentjobtitle && !candidateData?.currentcompany" class="f-12 text-9696 d-flex align-items-center"><i class="fa-regular fa-briefcase mr-1"></i> Designation <span class="d-flex"><i class="fa-solid fa-circle mx-2" style="color: #2E93A1; font-size: 5px;"></i></span> <span><i class="fa-regular fa-buildings mr-1"></i></span> Company</p>
      </div>
      <div class="col mb-3">
        <div class="percentage-match modalbtn"  [ngClass]="{
          'excellent-match-btn': candidateData?.category == 'EXCELLENT',
          'good-match-btn': candidateData?.category == 'GOOD',
          'potential-match-btn': candidateData?.category == 'POTENTIAL',
          'notamatch-match-btn': candidateData?.category == 'NOT_A_MATCH'
        }">{{candidateData?.overall_screening_score}} % | {{showMatchScore(candidateData?.category)}}</div>
      </div>
    </div>
    <div class="d-flex align-items-start">

       <button data-testid="auto-app-userprofile-button-2" type="button" class="close font-weight-normal " data-dismiss="modal" aria-label="Close"
      (click)="modalService.dismissAll()">
      <span aria-hidden="true">&times;</span>
    </button>
    </div>
  </div>

  <!-- <div class="candidatematch">
    <div class="d-flex exelentmatch mr-6">
      <div>
        <i class="fa-solid fa-thumbs-up"></i> <span class="text-9696 mx-1"> |</span> <span class="f-14">Excellent Match</span>
      </div>
      <div class="text-black ml-5">
        85% -  Above
      </div>
    </div>
    <div class="d-flex goodmatch">
      <div>
        <i class="fa-solid fa-thumbs-up"></i> <span class="text-9696 mx-1"> |</span> <span class="f-14">Good Match</span>
      </div>
      <div class="text-black ml-5">
        60% -  85%
      </div>
    </div>
  </div>
   <div class="candidatematch">
    <div class="d-flex potentialmatch mr-5">
      <div>
        <i class="fa-solid fa-thumbs-up"></i> <span class="text-9696 mx-1"> |</span> <span class="f-14">Potential Match</span>
      </div>
      <div class="text-black ml-5">
        40% -  60%
      </div>
    </div>
    <div class="d-flex notmatch">
      <div>
        <i class="fa-solid fa-thumbs-up"></i> <span class="text-9696 mx-1"> |</span> <span class="f-14">Not a Match</span>
      </div>
      <div class="text-black ml-5">
        0% -  40%
      </div>
    </div>
  </div> -->
  <hr class="mt-0">

  <p class="f-12 font-weight-500">Candidate Summary </p>
  <div class="mb-4">
    <p class="f-14 mb-1 summary-ai" [innerHTML]="formatAISummary(candidateData?.overall?.overall_score_explanation)">
     </p>

  </div>
  <div>
    <p class="text-9696 f-12 mb-2">AI Evaluation Insights</p>
          <div *ngFor="let criteria of candidateData?.screening_criteria; let i = index">

    <p  class="text-black f-14 mb-1 font-weight-500">{{criteria?.criteria_content | titlecase}}
      <span>
                  <i class="fa-solid fa-thumbs-up ml-1"
                    *ngIf="criteria?.match === 'full' || criteria?.match === 'partial'"
                    [ngStyle]="{ color: criteria?.match === 'full' ? '#229300' :
                                (criteria?.match === 'partial' ? '#FBA744' :
                                (criteria?.match === 'unmatched' ? '#CD0F0F8C' : 'inherit'))}">
                  </i>

                     <i class="fa-solid fa-thumbs-down ml-1"
                    *ngIf="criteria?.match === 'unmatched'" style="color: #CD0F0F8C;">
                  </i>
                </span>
    </p>
    <p class="text-black f-14 mb-3 font-weight-normal" [innerHTML]="criteria?.explanation"></p>
</div>

  </div>
  <hr>
  <div class="mb-2">
    <p class="f-12 font-weight-500 mb-1">How we calculate scores</p>
  </div >
  <div class="col-md-11 px-0 f-12">
    <div class="row">
      <div class="col-md-6 d-flex exelentmatch  mb-2">
        <div >
        <i class="fa-solid fa-thumbs-up f-12"></i> <span class="text-9696 mx-1"> |</span> <span class="f-12 font-weight-500">Excellent Match</span>
        </div>
        <div class="text-black ml-5 f-12">
          85% - Above
        </div>
      </div>
      <div class="col-md-6 d-flex goodmatch  mb-2">
        <div>
          <i class="fa-solid fa-thumbs-up f-12"></i> <span class="text-9696 mx-1"> |</span> <span class="f-12 font-weight-500">Good Match</span>
        </div>
        <div class="text-black ml-5 f-12">
          60% - 85%
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 d-flex potentialmatch  mb-2">
        <div >
        <i class="fa-solid fa-thumbs-up f-12"></i> <span class="text-9696 mx-1"> |</span> <span class="f-12 font-weight-500">Potential Match</span>
        </div>
        <div class="text-black ml-5 f-12">
          40% - 60%
        </div>
      </div>
      <div class="col-md-6 d-flex notmatch  mb-2">
        <div>
          <i class="fa-solid fa-thumbs-down f-12"></i> <span class="text-9696 mx-1"> |</span> <span class="f-12 font-weight-500">Not a Match</span>
        </div>
        <div class="text-black ml-5 f-12">
         0% - 40%
        </div>
      </div>
    </div>
  </div>
 </div>
</ng-template>

<ng-template #exportCsvEmailModal>
   <div class="modal-body">
      <div class="d-flex justify-content-between align-items-start">
    <div>
      <p class="font-weight-600 f-24">Send CSV to my inbox</p>

    </div>
    <div class="d-flex align-items-start">

       <button data-testid="auto-app-userprofile-button-3" type="button" class="close font-weight-normal ml-2 " data-dismiss="modal" aria-label="Close"
      (click)="modalService.dismissAll()">
      <span aria-hidden="true">&times;</span>
    </button>
    </div>
  </div>
  <form >
    <div class="row">
          <div class="col">
             <label for="Workemail">Email Address<span class="text-danger">*</span></label>
            <div class="input-form-linkedin-box  mb-0">
              <div class="linkedinbox d-flex">
                <div class="w-100">
                <input data-testid="auto-app-userprofile-input-1" type="text" placeholder="Enter your Work email here" class="wc-form-control"
              [formControl]="workEmail">
              <div class="posrelativeinmobile">
                <p class="text-danger f-12 pt-1 mb-0" style="position: absolute;"
                 *ngIf="workEmail.hasError('required') && (workEmail.dirty || workEmail.touched)">
                  This field is required</p>
                <p class="text-danger f-12 pt-1 mb-0" style="position: absolute;" *ngIf="workEmail.hasError('pattern')">
                  Invalid Email Id</p>
                <p class="text-danger f-12 pt-1 mb-0" style="position: absolute;" *ngIf="workEmail.hasError('invaliDomain')">
                  Invalid Domain</p>

              </div>
              </div>
                  <div>
                <button data-testid="auto-app-userprofile-button-4" class="btn-form-submit btn-disable" [ngClass]="{'btn-active': workEmail.valid}"
                  (click)="register()">
                  <span [ngClass]="{ 'spinner-border text-light spinner-size': showFreeTrialLoader}" [ngStyle] = "{ 'width: 250px; height: 20px;': showFreeTrialLoader }">
                    {{showFreeTrialLoader ? '' : 'Send CSV'}}
                  </span>
                  </button>
              </div>
              </div>

            </div>


          </div>
        </div>

        <div class="row mt-5">
          <div class="col">
            <p class="f-12 text-484b59">By proceeding, you agree to our <a data-testid="auto-app-userprofile-a-1" class="text-webbtree-green" href="https://www.webbtree.com/terms-and-conditions" target="_blank">Terms & Conditions</a> and <a data-testid="auto-app-userprofile-a-2" class="text-webbtree-green" href="https://www.webbtree.com/privacy-policy" target="_blank">Privacy Policy</a></p>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <p class="text-danger f-12 pt-1" *ngIf="showErrorMsg">{{showErrorMsg}}</p>
          </div>
        </div>
      </form>


</div>
</ng-template>

<ng-template #exportSuccessModal>
   <div class="modal-body text-center">
        <div class="d-flex align-items-end float-right">

       <button data-testid="auto-app-userprofile-button-5" type="button" class="close font-weight-normal ml-2 " data-dismiss="modal" aria-label="Close"
      (click)="modalService.dismissAll()">
      <span aria-hidden="true">&times;</span>
    </button>
    </div>
      <div class="justify-content-center align-items-center mb-3">
    <div class="mb-2">
      <img src="../../../assets/images/exportCSVSucces.gif" alt="success" class="img-fluid" style="width: 50px; height: 50px;">
    </div>
    <div>
      <p class="font-weight-600 f-18">The file has been successfully sent to your email.</p>
    </div>
  </div>
  </div>
</ng-template>

<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>
